'use client';

import type { ComponentProps } from 'react';
import cx from 'clsx';

import { Overlay } from './Overlay';

type Props = {
  hideDismiss?: boolean;
} & ComponentProps<typeof Overlay>;

export function CloseButtonWithOverlay({
  hideDismiss = true,
  children,
  className,
  ...props
}: Props) {
  return (
    <Overlay className={cx(className, 'fixed z-[25]')} {...props}>
      {!hideDismiss && (
        <button
          className="fixed right-20 top-24 z-[25]"
          type="button"
          onClick={(e) => {
            e.preventDefault();
            props.onClick?.();
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.2197 3.71967C19.5126 3.42678 19.9873 3.42678 20.2802 3.71967C20.5731 4.01256 20.5731 4.48732 20.2802 4.78022L13.0605 11.9999L20.2802 19.2197C20.5731 19.5126 20.5731 19.9873 20.2802 20.2802C19.9873 20.5731 19.5126 20.5731 19.2197 20.2802L11.9999 13.0605L4.78022 20.2802C4.48732 20.5731 4.01256 20.5731 3.71967 20.2802C3.42678 19.9873 3.42678 19.5126 3.71967 19.2197L10.9394 11.9999L3.71967 4.78022C3.42678 4.48732 3.42678 4.01256 3.71967 3.71967C4.01256 3.42678 4.48732 3.42678 4.78022 3.71967L11.9999 10.9394L19.2197 3.71967Z"
              fill="#fff"
            />
          </svg>
        </button>
      )}
      <div className="fixed inset-0 flex h-full items-center justify-center">
        {children}
      </div>
    </Overlay>
  );
}
